/* eslint-disable */
// This file is auto-generated by scripts/generate-docs-registry.mjs
// Do not edit directly.
import Doc0, { frontmatter as frontmatter0 } from "../../api-node/tsMainRepo/src/services/promotion/_doc.mdx";
import Doc1, { frontmatter as frontmatter1 } from "../../app-enterprise/_doc.mdx";
import Doc2, { frontmatter as frontmatter2 } from "../../app-react-auth-site/_doc.mdx";
import Doc3, { frontmatter as frontmatter3 } from "../../app-react-auth-site/src/layouts/_doc.mdx";
import Doc4, { frontmatter as frontmatter4 } from "../../app-react-auth-site/src/pages/_doc.mdx";
import Doc5, { frontmatter as frontmatter5 } from "../../app-react/_doc.mdx";
import Doc6, { frontmatter as frontmatter6 } from "../../app-react/src/rezi-app/dashboard/_doc.mdx";
import Doc7, { frontmatter as frontmatter7 } from "../../app-react/src/rezi-app/dashboard/components/jobs/_doc.mdx";
import Doc8, { frontmatter as frontmatter8 } from "../../micro-services/activity-log/_doc.mdx";
import Doc9, { frontmatter as frontmatter9 } from "../../micro-services/ats-checker/_doc.mdx";
import Doc10, { frontmatter as frontmatter10 } from "../../micro-services/company-service/_doc.mdx";
import Doc11, { frontmatter as frontmatter11 } from "../../micro-services/cover-letter-service-go/_doc.mdx";
import Doc12, { frontmatter as frontmatter12 } from "../../micro-services/db-api/_doc.mdx";
import Doc13, { frontmatter as frontmatter13 } from "../../micro-services/docs-search/_doc.mdx";
import Doc56, { frontmatter as frontmatter56 } from "../../micro-services/enterprise/_doc.mdx";
import Doc57, { frontmatter as frontmatter57 } from "../../micro-services/go-shared/apiserver/_doc.mdx";
import Doc58, { frontmatter as frontmatter58 } from "../../micro-services/go-shared/callers/_doc.mdx";
import Doc59, { frontmatter as frontmatter59 } from "../../micro-services/go-shared/config/_doc.mdx";
import Doc60, { frontmatter as frontmatter60 } from "../../micro-services/go-shared/documentbuilder/_doc.mdx";
import Doc61, { frontmatter as frontmatter61 } from "../../micro-services/go-shared/entities/_doc.mdx";
import Doc62, { frontmatter as frontmatter62 } from "../../micro-services/go-shared/errs/_doc.mdx";
import Doc63, { frontmatter as frontmatter63 } from "../../micro-services/go-shared/llms/_doc.mdx";
import Doc64, { frontmatter as frontmatter64 } from "../../micro-services/go-shared/middleware/_doc.mdx";
import Doc65, { frontmatter as frontmatter65 } from "../../micro-services/go-shared/models/_doc.mdx";
import Doc66, { frontmatter as frontmatter66 } from "../../micro-services/go-shared/resumes/_doc.mdx";
import Doc67, { frontmatter as frontmatter67 } from "../../micro-services/image-service-go/_doc.mdx";
import Doc68, { frontmatter as frontmatter68 } from "../../micro-services/interview/_doc.mdx";
import Doc69, { frontmatter as frontmatter69 } from "../../micro-services/orders-service-go/_doc.mdx";
import Doc70, { frontmatter as frontmatter70 } from "../../micro-services/payment-service-go/_doc.mdx";
import Doc71, { frontmatter as frontmatter71 } from "../../micro-services/pdf-download-service/_doc.mdx";
import Doc72, { frontmatter as frontmatter72 } from "../../micro-services/resignation-letter-service-go/_doc.mdx";
import Doc73, { frontmatter as frontmatter73 } from "../../micro-services/resume-analyzer/_doc.mdx";
import Doc74, { frontmatter as frontmatter74 } from "../../micro-services/resume-parser-service-go/_doc.mdx";
import Doc75, { frontmatter as frontmatter75 } from "../../micro-services/resume-service-go/_doc.mdx";
import Doc76, { frontmatter as frontmatter76 } from "../../micro-services/rezi-mcp/_doc.mdx";
import Doc77, { frontmatter as frontmatter77 } from "../../micro-services/world-map-search/_doc.mdx";
import Doc78, { frontmatter as frontmatter78 } from "../../../libs/features/_doc.mdx";
import Doc79, { frontmatter as frontmatter79 } from "../../../libs/features/src/ab-testing/_doc.mdx";
import Doc80, { frontmatter as frontmatter80 } from "../../../libs/features/src/keyword-tool/_doc.mdx";
import Doc81, { frontmatter as frontmatter81 } from "../../../libs/utils/_doc.mdx";
import Doc82, { frontmatter as frontmatter82 } from "../../../libs/utils/src/session-timeout/_doc.mdx";

export const generatedDocs = [
  {
    frontmatter: frontmatter0,
    Content: Doc0,
    sourcePath: "apps/api-node/tsMainRepo/src/services/promotion/_doc.mdx",
    categoryPath: "api-node/tsMainRepo/src/services/promotion",
    changelog: ["2026-09-08: Created."],
  },
  {
    frontmatter: frontmatter1,
    Content: Doc1,
    sourcePath: "apps/app-enterprise/_doc.mdx",
    categoryPath: "app-enterprise",
    changelog: ["2026-01-27: Expanded product and technical overviews to cover business logic and key code paths.","2026-01-27: Initial documentation."],
  },
  {
    frontmatter: frontmatter2,
    Content: Doc2,
    sourcePath: "apps/app-react-auth-site/_doc.mdx",
    categoryPath: "app-react-auth-site",
    changelog: ["2026-02-19: Added Cloudflare `astro-auth` worker routing behavior and Netlify proxy details.","2026-02-19: Initial documentation for `apps/app-react-auth-site` root."],
  },
  {
    frontmatter: frontmatter3,
    Content: Doc3,
    sourcePath: "apps/app-react-auth-site/src/layouts/_doc.mdx",
    categoryPath: "app-react-auth-site/layouts",
    changelog: ["2026-02-19: Initial layouts documentation for `apps/app-react-auth-site/src/layouts`."],
  },
  {
    frontmatter: frontmatter4,
    Content: Doc4,
    sourcePath: "apps/app-react-auth-site/src/pages/_doc.mdx",
    categoryPath: "app-react-auth-site/pages",
    changelog: ["2026-02-19: Initial pages documentation for `apps/app-react-auth-site/src/pages`."],
  },
  {
    frontmatter: frontmatter5,
    Content: Doc5,
    sourcePath: "apps/app-react/_doc.mdx",
    categoryPath: "app-react",
    changelog: ["2026-01-27: Expanded product and technical overviews to cover business logic and key code paths.","2026-01-23: Initial documentation."],
  },
  {
    frontmatter: frontmatter6,
    Content: Doc6,
    sourcePath: "apps/app-react/src/rezi-app/dashboard/_doc.mdx",
    categoryPath: "app-react/rezi-app/dashboard",
    changelog: ["2026-01-27: Expanded product and technical overviews to cover business logic and key code paths.","2026-01-26: Initial documentation."],
  },
  {
    frontmatter: frontmatter7,
    Content: Doc7,
    sourcePath: "apps/app-react/src/rezi-app/dashboard/components/jobs/_doc.mdx",
    categoryPath: "app-react/rezi-app/dashboard/components/jobs",
    changelog: ["2026-05-21: Module deleted. `dashboard/components/jobs/jobs.tsx`, `jobs/hooks/use-job-recommendations.ts`, and the associated `useJobPreferences` / `useUpdateJobPreferences` / `useJobRecommendations` hooks were removed. The dashboard recommendations carousel has been replaced by the unified job board (`src/rezi-app/jobs`).","2026-01-27: Expanded product and technical overviews to cover business logic and key code paths.","2026-01-26: Marked inactive and confidential (not currently used).","2026-01-26: Initial documentation."],
  },
  {
    frontmatter: frontmatter8,
    Content: Doc8,
    sourcePath: "apps/micro-services/activity-log/_doc.mdx",
    categoryPath: "micro-services/activity-log",
    changelog: ["2026-02-03: Can have custom token","2026-01-30: Added the OpenAPI spec generator entry point.","2026-01-30: Initial documentation."],
  },
  {
    frontmatter: frontmatter9,
    Content: Doc9,
    sourcePath: "apps/micro-services/ats-checker/_doc.mdx",
    categoryPath: "micro-services/ats-checker",
    changelog: [],
  },
  {
    frontmatter: frontmatter10,
    Content: Doc10,
    sourcePath: "apps/micro-services/company-service/_doc.mdx",
    categoryPath: "micro-services/company-service",
    changelog: ["2026-02-03: Can have custom token","2026-01-30: Added the OpenAPI spec generator entry point.","2026-01-30: Initial documentation."],
  },
  {
    frontmatter: frontmatter11,
    Content: Doc11,
    sourcePath: "apps/micro-services/cover-letter-service-go/_doc.mdx",
    categoryPath: "micro-services/cover-letter-service-go",
    changelog: ["2026-02-03: Can have custom token","2026-01-30: Added the OpenAPI spec generator entry point.","2026-01-30: Initial documentation."],
  },
  {
    frontmatter: frontmatter12,
    Content: Doc12,
    sourcePath: "apps/micro-services/db-api/_doc.mdx",
    categoryPath: "micro-services/db-api",
    changelog: ["2026-01-30: Added the OpenAPI spec generator entry point.","2026-01-30: Initial documentation."],
  },
  {
    frontmatter: frontmatter13,
    Content: Doc13,
    sourcePath: "apps/micro-services/docs-search/_doc.mdx",
    categoryPath: "micro-services/docs-search",
    changelog: ["2026-01-23: Initial documentation."],
  },
  {
    frontmatter: frontmatter56,
    Content: Doc56,
    sourcePath: "apps/micro-services/enterprise/_doc.mdx",
    categoryPath: "micro-services/enterprise",
    changelog: ["2026-02-03: Can have custom token","2026-02-02: Initial documentation."],
  },
  {
    frontmatter: frontmatter57,
    Content: Doc57,
    sourcePath: "apps/micro-services/go-shared/apiserver/_doc.mdx",
    categoryPath: "micro-services/go-shared/apiserver",
    changelog: ["2026-01-30: Initial documentation."],
  },
  {
    frontmatter: frontmatter58,
    Content: Doc58,
    sourcePath: "apps/micro-services/go-shared/callers/_doc.mdx",
    categoryPath: "micro-services/go-shared/callers",
    changelog: ["2026-01-30: Initial documentation."],
  },
  {
    frontmatter: frontmatter59,
    Content: Doc59,
    sourcePath: "apps/micro-services/go-shared/config/_doc.mdx",
    categoryPath: "micro-services/go-shared/config",
    changelog: ["2026-02-04: Updated behavior to reflect `env.go` helpers, shared Postgres config decoding, and current entry points.","2026-01-30: Initial documentation."],
  },
  {
    frontmatter: frontmatter60,
    Content: Doc60,
    sourcePath: "apps/micro-services/go-shared/documentbuilder/_doc.mdx",
    categoryPath: "micro-services/go-shared/documentbuilder",
    changelog: ["2026-01-30: Initial documentation."],
  },
  {
    frontmatter: frontmatter61,
    Content: Doc61,
    sourcePath: "apps/micro-services/go-shared/entities/_doc.mdx",
    categoryPath: "micro-services/go-shared/entities",
    changelog: ["2026-01-30: Initial documentation."],
  },
  {
    frontmatter: frontmatter62,
    Content: Doc62,
    sourcePath: "apps/micro-services/go-shared/errs/_doc.mdx",
    categoryPath: "micro-services/go-shared/errs",
    changelog: ["2026-01-30: Initial documentation."],
  },
  {
    frontmatter: frontmatter63,
    Content: Doc63,
    sourcePath: "apps/micro-services/go-shared/llms/_doc.mdx",
    categoryPath: "micro-services/go-shared/llms",
    changelog: ["2026-01-30: Initial documentation."],
  },
  {
    frontmatter: frontmatter64,
    Content: Doc64,
    sourcePath: "apps/micro-services/go-shared/middleware/_doc.mdx",
    categoryPath: "micro-services/go-shared/middleware",
    changelog: ["2026-02-03: Can have custom token","2026-01-30: Initial documentation."],
  },
  {
    frontmatter: frontmatter65,
    Content: Doc65,
    sourcePath: "apps/micro-services/go-shared/models/_doc.mdx",
    categoryPath: "micro-services/go-shared/models",
    changelog: ["2026-01-30: Initial documentation."],
  },
  {
    frontmatter: frontmatter66,
    Content: Doc66,
    sourcePath: "apps/micro-services/go-shared/resumes/_doc.mdx",
    categoryPath: "micro-services/go-shared/resumes",
    changelog: ["2026-01-30: Initial documentation."],
  },
  {
    frontmatter: frontmatter67,
    Content: Doc67,
    sourcePath: "apps/micro-services/image-service-go/_doc.mdx",
    categoryPath: "micro-services/image-service-go",
    changelog: ["2026-02-02: Initial documentation."],
  },
  {
    frontmatter: frontmatter68,
    Content: Doc68,
    sourcePath: "apps/micro-services/interview/_doc.mdx",
    categoryPath: "micro-services/interview",
    changelog: ["2026-02-03: Can have custom token","2026-02-02: Initial documentation."],
  },
  {
    frontmatter: frontmatter69,
    Content: Doc69,
    sourcePath: "apps/micro-services/orders-service-go/_doc.mdx",
    categoryPath: "micro-services/orders-service-go",
    changelog: ["2026-02-03: Can have custom token","2026-02-02: Initial documentation."],
  },
  {
    frontmatter: frontmatter70,
    Content: Doc70,
    sourcePath: "apps/micro-services/payment-service-go/_doc.mdx",
    categoryPath: "micro-services/payment-service-go",
    changelog: ["2026-02-03: Can have custom token","2026-02-02: Initial documentation."],
  },
  {
    frontmatter: frontmatter71,
    Content: Doc71,
    sourcePath: "apps/micro-services/pdf-download-service/_doc.mdx",
    categoryPath: "micro-services/pdf-download-service",
    changelog: ["2026-02-03: Can have custom token","2026-02-02: Initial documentation."],
  },
  {
    frontmatter: frontmatter72,
    Content: Doc72,
    sourcePath: "apps/micro-services/resignation-letter-service-go/_doc.mdx",
    categoryPath: "micro-services/resignation-letter-service-go",
    changelog: ["2026-02-02: Initial documentation."],
  },
  {
    frontmatter: frontmatter73,
    Content: Doc73,
    sourcePath: "apps/micro-services/resume-analyzer/_doc.mdx",
    categoryPath: "micro-services/resume-analyzer",
    changelog: ["2026-02-03: Can have custom token","2026-01-30: Added the OpenAPI spec generator entry point.","2026-01-30: Initial documentation."],
  },
  {
    frontmatter: frontmatter74,
    Content: Doc74,
    sourcePath: "apps/micro-services/resume-parser-service-go/_doc.mdx",
    categoryPath: "micro-services/resume-parser-service-go",
    changelog: ["2026-02-03: Can have custom token","2026-02-02: Initial documentation."],
  },
  {
    frontmatter: frontmatter75,
    Content: Doc75,
    sourcePath: "apps/micro-services/resume-service-go/_doc.mdx",
    categoryPath: "micro-services/resume-service-go",
    changelog: ["2026-02-03: Can have custom token","2026-01-30: Noted the OpenAPI spec generator entry point.","2026-01-30: Documented the LinkedIn transformator migration binary.","2026-01-30: Initial documentation."],
  },
  {
    frontmatter: frontmatter76,
    Content: Doc76,
    sourcePath: "apps/micro-services/rezi-mcp/_doc.mdx",
    categoryPath: "micro-services/rezi-mcp",
    changelog: ["2026-04-14: Added initial internal documentation for the service and documented the current OAuth, subscription, resume, and job-search behavior.","2026-07-15: Aligned resume-format guidance and validation with the internal MCP's canonical resume contract.","2026-08-31: Made authenticated MCP tool access available without a paid Rezi subscription."],
  },
  {
    frontmatter: frontmatter77,
    Content: Doc77,
    sourcePath: "apps/micro-services/world-map-search/_doc.mdx",
    categoryPath: "micro-services/world-map-search",
    changelog: ["2026-01-29: Initial documentation."],
  },
  {
    frontmatter: frontmatter78,
    Content: Doc78,
    sourcePath: "libs/features/_doc.mdx",
    categoryPath: "features",
    changelog: ["2026-01-27: Expanded product and technical overviews to cover business logic and key code paths.","2026-01-22: Updated overview content to reflect usage and folder context.","2026-01-21: Replaced `audience` with `visibility` in frontmatter."],
  },
  {
    frontmatter: frontmatter79,
    Content: Doc79,
    sourcePath: "libs/features/src/ab-testing/_doc.mdx",
    categoryPath: "features/ab-testing",
    changelog: ["2026-01-27: Created."],
  },
  {
    frontmatter: frontmatter80,
    Content: Doc80,
    sourcePath: "libs/features/src/keyword-tool/_doc.mdx",
    categoryPath: "features/keyword-tool",
    changelog: ["2026-01-27: Expanded product and technical overviews to cover business logic and key code paths.","2026-01-21: Created."],
  },
  {
    frontmatter: frontmatter81,
    Content: Doc81,
    sourcePath: "libs/utils/_doc.mdx",
    categoryPath: "utils",
    changelog: ["2026-01-27: Expanded product and technical overviews to cover business logic and key code paths.","2026-01-26: Updated frontmatter id to match kebabcase path.","2026-01-22: Updated overview content to reflect usage and folder context.","2026-01-21: Replaced `audience` with `visibility` in frontmatter."],
  },
  {
    frontmatter: frontmatter82,
    Content: Doc82,
    sourcePath: "libs/utils/src/session-timeout/_doc.mdx",
    categoryPath: "utils/session-timeout",
    changelog: ["2026-01-27: Expanded product and technical overviews to cover business logic and key code paths.","2026-01-23: Initial documentation."],
  },
];
